






import { Component } from "vue-property-decorator";
import RoundButtonBase from "./base/RoundButtonBase.vue";
import EditIcon from "@share/common/icons/EditIcon.vue";

@Component({ components: { EditIcon } })

export default class CardEditButton extends RoundButtonBase {}

